<template>
  <div>
    <app-link
      v-for="index in links.length"
      :key="index"
      :index="index - 1"
      :link="links[index - 1]"
     
      @clicked="openLink"
    >
    </app-link>
  </div>
</template>

<script>
import Link from "./Link";
export default {
  components: {
    appLink: Link,
  },
  created() {
    this.$store.dispatch("getLinks");
  },
  computed: {
    links() {
      return this.$store.getters.links;
    },
  },
  methods: {
    openLink(index) {
      window.open(this.links[index].LinkAddress);
    },
  },
};
</script>
<style>
</style>
